import styled from 'styled-components';

export const PlaygroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  width: 100%;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;

  @media (min-width: 600px) {
    padding-left: 24px;
    padding-right: 24px;
  }

  @media (min-width: 1440px) {
    padding-left: 32px;
    padding-right: 32px;
  }

  @media (min-width: 1920px) {
    padding-left: 80px;
    padding-right: 80px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
`;

export const ContentArea = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 24px;
  overflow: hidden;
`;

export const RoutesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  max-width: calc(50% - 12px);
  overflow: auto;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

